import styled from "styled-components"
import { FlexWrapper } from "components/ui/FlexWrapper/styles"

export const Wrapper = styled(FlexWrapper)`
  padding: 0 1.5rem;
  max-width: 100vw;

  ${({ theme }) => theme.breakpoints.tablet} {
    max-width: 100%;
  }
  ${({ theme }) => theme.breakpoints.smallDesktop} {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 3rem 0 7.5rem;

    div {
      &:first-child,
      &:last-child {
        flex-basis: 25%;
      }

      &:nth-child(2) {
        flex-basis: 27%;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.desktop} {
    padding: 0 0 7.5rem;
  }
`
